import List from "@/components/list";

const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "学院名称",
      prop: "deptName"
    },
    {
      label: "共享状态",
      prop: "sharedStatusName"
    },
    {
      label: "是否删除",
      prop: "isDeleteName"
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
